const INITIAL_STATE = {
  usuarioList: [],
  usuario: null,
  usuarioPagination: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'USUARIO_FETCH':
      return { ...state, usuarioList: action.payload }
    case 'USUARIO_SET':
      return { ...state, usuario: action.payload }
    case 'USUARIO_PAGINATION':
      return { ...state, usuarioPagination: action.payload }
    default:
      return state
  }
}